import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../../utils/api';


export const signupUser = createAsyncThunk(
  'signup/signupUser',
  async (userData: any, { rejectWithValue, getState }) => {
    try {
      // 1. Separate files from text data
      const jsonFields: any = {};
      const fileFields: { field_id: number, file: File, expiry?: string, issue?: string }[] = [];
      
      const { signup } = getState() as any;
      const allFields = signup.fields || [];

      Object.keys(userData).forEach(key => {
        const fieldConfig = allFields.find((f: any) => f.name === key);
        if (fieldConfig && fieldConfig.field_type === 'file' && userData[key] instanceof File) {
          fileFields.push({
            field_id: fieldConfig.field_id,
            file: userData[key],
            expiry: userData[`${key}_expiry`],
            issue: userData[`${key}_issue`]
          });
        } else if (!key.endsWith('_expiry') && !key.endsWith('_issue')) {
          jsonFields[key] = userData[key];
        }
      });

      // 2. Submit Core Data as JSON
      const response = await apiCall<{ data: any }>('POST', '/api/organization/create/', jsonFields);
      const orgData = response.data.data;
      const orgId = orgData.org_id || orgData.id;

      if (!orgId) {
        throw new Error('Organization created but no ID returned');
      }

      // 3. Upload Files Sequentially
      for (const item of fileFields) {
        const fileFormData = new FormData();
        fileFormData.append('org_id', orgId.toString());
        fileFormData.append('field_id', item.field_id.toString());
        fileFormData.append('file', item.file);
        if (item.expiry) fileFormData.append('expiry_date', item.expiry);
        if (item.issue) fileFormData.append('issue_date', item.issue);

        await apiCall('POST', '/api/organization/signup/document-upload/', fileFormData);
      }

      return orgData;
    } catch (error: any) {
      const errorMsg = error.response?.data?.message || error.message || 'Signup failed';
      return rejectWithValue(errorMsg);
    }
  }
);

export const fetchSignupFields = createAsyncThunk(
  'signup/fetchFields',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<any>('GET', '/api/superadmin/public/signup-fields/');
      const data = response.data;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.data)) return data.data;
      if (data && Array.isArray(data.results)) return data.results;
      return [];
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch signup fields');
    }
  }
);
